<script lang="ts" setup>
import SpinningDots from './SpinningDots.vue'
</script>

<template>
  <SpinningDots class="py-32" style="min-height: 70vh" />
</template>
